import { Component } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Store } from "@ngrx/store";
import * as NavigationActions from 'src/app/store/common/navigation/navigation.actions';
import { selectNavigation } from 'src/app/store/common/navigation/navigation.selector';

@Component({
  selector: 'base',
  template: '',
  styleUrls: []
})
export class BaseComponent {
  submitting = false;

  constructor(public store: Store) {
    this.loadNavigation();
  }

  loadNavigation() {
    this.store.select(selectNavigation)
      .subscribe(data => {
        this.submitting = data.loading;
      });
  }

  formValidation(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control: FormGroup) => {
      control.markAsTouched();
      control.updateValueAndValidity();
      if (control.controls) { this.formValidation(control); }
    });

    this.hideSpinner();
  }

  hideSpinner() {
    this.store.dispatch(NavigationActions.hideSpinner({}));
  }

  formReset(formgroup: FormGroup) {
    for (let controller in formgroup.controls) {
      formgroup.get(controller)?.reset(undefined);
      formgroup.get(controller)?.markAsUntouched();
      formgroup.get(controller)?.markAsPristine();
      formgroup.get(controller)?.updateValueAndValidity();
    }
  }

  confirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (matchingControl.errors && !matchingControl.errors['confirmedValidator']) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    }
  }

  scrollToId(id: string) {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }
}